import { useParams } from "react-router-dom";
import FormActions, {
  SchemaFormAction,
} from "../../components/forms/FormActionNew/FormAction";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import { useCrudAction } from "../../features/api/crud/hooks/useCrudAction";
import styles from "./PageActionCreate.module.scss";
import { useMemo } from "react";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import dayjs from "dayjs";
import {
  useFetchEventQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";

const PageActionCreate: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();

  const { onSubmit, isLoading, isPostingAttachments } = useCrudAction();

  const { data: event, isFetching: isFetchingEvent } = useFetchEventQuery(
    Number(eventId),
    {
      skip: !eventId,
    },
  );

  const { data: dataPerformers, isFetching: isFetchingPorformers } =
    useFetchUsersForFieldQuery("");

  const defaultValues: SchemaFormAction = useMemo(() => {
    return {
      dateAsked: dayjs(),
      date: dayjs(),
      causeType: "CORRECTIF",
      title: "",
      description: "",
      effacity: "",
      pilote: "",
      performer: "",
      event: String(eventId),
    };
  }, [eventId]);

  const isPageLoading =
    isLoading ||
    isFetchingEvent ||
    isFetchingPorformers ||
    isPostingAttachments;

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      <Breadcrumbs
        pageName="newAction"
        eventName={event?.name}
        eventId={Number(eventId)}
      />
      <FormActions
        onSubmit={onSubmit}
        isLoading={isLoading || isPostingAttachments}
        defaultValues={defaultValues}
        performers={dataPerformers || []}
      />
    </PageLayout>
  );
};

export default PageActionCreate;
